import React from 'react';
import { branding } from '../../utils';

export const EarthFooter = () => (
  <footer className="footer">© {new Date().getFullYear()} {branding.brandName}</footer>
);
